import { TextInputBase } from './text-input-base';

interface TextInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  error?: string;
}

export const TextInput = ({ value, onChange, placeholder, error}: TextInputProps) => {
  return (
    <div className="questionnaire-question-content">
      <TextInputBase 
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        error={error}
      />
    </div>
  );
};
